export default function AccessDenied() {
  return (
    <div className="h-[50vh] justify-center flex flex-col align-middle items-center gap-6">
      <h1 className="text-8xl font-bold text-red-500">403</h1>
      <h2 className="text-xl">Bạn không có quyền truy cập trang này</h2>
    </div>
  )
}
